"use strict";
var _assign = require("babel-runtime/core-js/object/assign"),
  _assign2 = _interopRequireDefault(_assign),
  _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of"),
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf),
  _classCallCheck2 = require("babel-runtime/helpers/classCallCheck"),
  _classCallCheck3 = _interopRequireDefault(_classCallCheck2),
  _createClass2 = require("babel-runtime/helpers/createClass"),
  _createClass3 = _interopRequireDefault(_createClass2),
  _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn"),
  _possibleConstructorReturn3 = _interopRequireDefault(
    _possibleConstructorReturn2
),
  _inherits2 = require("babel-runtime/helpers/inherits"),
  _inherits3 = _interopRequireDefault(_inherits2),
  _react = require("react"),
  _react2 = _interopRequireDefault(_react),
  _propTypes = require("prop-types"),
  _propTypes2 = _interopRequireDefault(_propTypes),
  _d = require("d3");
Object.defineProperty(exports, "__esModule", { value: !0 });
function _interopRequireDefault(a) {
  return a && a.__esModule ? a : { default: a };
}
var ReactSpeedometer = (function(a) {
  function b(a) {
(0, _classCallCheck3.default)(this, b);
    var c = (0, _possibleConstructorReturn3.default)(
      this,
(b.__proto__ || (0, _getPrototypeOf2.default)(b)).call(this, a)
);
    return (
(c.render = function() {
        return _react2.default.createElement("div", {
          ref: function ref(a) {
            return (c.gaugeDiv = a);
}
});
}),
(c._d3_refs = { powerGauge: !1 }),
(c.initialValue = 0),
      c
);
}
  return (
(0, _inherits3.default)(b, a),
(0, _createClass3.default)(b, [
{ key: "componentWillMount", value: function componentWillMount() {} },
{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.renderGauge();
}
},
{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps() {
          this.initialValue = this.props.value || 0;
}
},
{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(a) {
          return !0;
}
},
{ key: "componentWillUpdate", value: function componentWillUpdate() {} },
{
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          this.props.forceRender ? this.renderGauge() : this.updateReadings();
}
},
{
        key: "getGauge",
        value: function getGauge() {
          var a = this,
            b = this.props;
          return function(c) {
            function e(a) {
              return (a * Math.PI) / 180;
}
            function d() {
(k = j.maxAngle - j.minAngle),
(i = j.width / 2),
(l = Math.round(i * j.pointerHeadLengthPercent)),
(o = (0, _d.scaleLinear)()
.range([0, 1])
.domain([j.minValue, j.maxValue])),
(p = o.ticks(j.majorTicks)),
                1 === p.length && (p = [j.minValue, j.maxValue]),
(q = (0, _d.range)(j.majorTicks).map(function() {
                  return 1 / j.majorTicks;
})),
(n = (0, _d.arc)()
.innerRadius(i - j.ringWidth - j.ringInset)
.outerRadius(i - j.ringInset)
.startAngle(function(a, b) {
                    return e(j.minAngle + a * b * k);
})
.endAngle(function(a, b) {
                    return e(j.minAngle + a * (b + 1) * k);
}));
}
            function f() {
              return "translate(" + i + "," + i + ")";
}
            function g(a) {
              var b = j.labelFormat(a);
              return j.currentValueText.replace("${value}", b);
              var c = (function(a, b) {
                return new Function(b, "return `" + a + "`;");
})(j.currentValueText, "value");
}

            
    
          
      
            var h = {
                ringInset: 20,
                pointerWidth: 5,
                pointerTailLength: 5,
                pointerHeadLengthPercent: 1,
                minAngle: -90,
                maxAngle: 90,
                labelInset: 10,
                parentWidth: a.gaugeDiv.parentNode.clientWidth,
                parentHeight: a.gaugeDiv.parentNode.clientHeight
},
              j = {
                width: b.fluidWidth ? h.parentWidth : b.width,
                height: b.fluidWidth ? h.parentHeight : b.height,
                ringWidth: b.ringWidth,
                minValue: b.minValue,
                maxValue: b.maxValue,
                needleColor: b.needleColor,
                majorTicks: b.segments,
                needleHeightRatio: 0.1,
                arcColorFn: (0, _d.interpolateHsl)(
(0, _d.rgb)(b.startColor),
(0, _d.rgb)(b.endColor)
),
                needleTransition: b.needleTransition,
                needleTransitionDuration: b.needleTransitionDuration,
                textColor: b.textColor,
                labelFormat: (0, _d.format)(b.valueFormat),
                currentValueText: b.currentValueText
};
            j = (0, _assign2.default)({}, h, j);
            var k,
              i,
              l,
              m,
              n,
              o,
              p,
              q,
              r = (0, _d.pie)();
            return (
              d(),
{
                configure: d,
                isRendered: function() {
                  return void 0 != m;
},
                render: function() {


                  var arc = _d.arc()
.innerRadius(j.width*0.9/2)
.outerRadius(j.width*0.9/2 + 30);
      
                  //Draw the arcs themselves
          _d.selectAll(".speedo-segment")
.attr("id", function(d,i) { return "speedo-segment_"+i; })
          // .attr("d", arc);


                  m = (0, _d.select)(c)
.append("svg:svg")
.attr("class", "speedometer")
.attr("width", j.width)
                    // .attr("height", j.height);
.attr("height", "180");
                  var b = f(),
                    d = m
.append("g")
.attr("class", "arc")
.attr("transform", b);
                  d.selectAll("path")
.data(q)
.enter()
.append("path")
.attr("class", "speedo-segment")
.attr("fill", function(a, b) {
                      return j.arcColorFn(a * b);
})
.attr("d", n);
                  var e = m
.append("g")
.attr("class", "label")
.attr("transform", b);
                  e
.selectAll("text")
.data(p)
.enter()
.append("text")
.attr("transform", function(a) {
                      var b = o(a),
                        c = j.minAngle + b * k;
                      return (
"rotate(" +
                        c +
") translate(0," +
(j.labelInset - i) +
")"
);
})
.text(
                        j.labelFormat
)
                   

                    
                    // .attr('x','40')
                    // .attr('y','40')
                    // .attr("dy", "18") 
.attr("class", "segment-value")
.attr("x", 20) //Move the text from the start angle of the arc
      .attr("dy", 35) //Move the text down
     // .append("textPath")
    //  .attr("href",function(d,lm){
    // return "#speedo-segment_"+lm;
    // }).text(
    // j.labelFormat
    // )
.style("text-anchor", "start")
.style("font-size", "10px")
.style("font-weight", "bold")
.style("fill", "#fff"),
(a._d3_refs.current_value_text = m
.append("g")
.attr(
"transform",
"translate(" + j.width / 2 + "," + j.width / 2 + ")"
)
// .append("text")
// .attr("class", "current-value")
// .attr("text-anchor", "middle")
// .attr("y", 23)
// .text("" || "")
.style("font-size", "16px")
.style("font-weight", "bold")
.style("fill", j.textColor));
                  var g = [
[ j.pointerWidth / 2, 0],
[0, -l + 42],
[-(j.pointerWidth / 2), 0],
[0, j.pointerTailLength],
[j.pointerWidth / 2, 0]
],
                    h = (0, _d.line)().curve(_d.curveMonotoneX),
                    r = m
.append("g")
.data([g])
.attr("class", "pointer")
  
                       // .append("line")
    // .attr("x1", 0)
    // .attr("y1", 0)
    // .attr("x2", 0)
    // .attr("y2", -102)
    // .attr("stroke-width", 6)
    // .attr("stroke", "coral")
.attr("y2", -102)

                      // .data([g])
.attr("height","100")
.attr("class", "pointer")
.attr("transform", b)
.style("fill", j.needleColor);
                  a._d3_refs.pointer = r
.append("path")
.attr("d", h)
.attr("transform", "rotate(" + j.minAngle + ")");

                  // var list = _d.selectAll(".segment-value").attr("fill","red !important").text('1234');

                  // for(var lp=0;lp<list._groups[0].length;lp++){

                  // list._groups[0].enter().text("text"+lp);
                  // }
                  
                  (j.majorTicks === 5 ? p : q).forEach((element, index) => {
                    element = j.majorTicks === 5 ? element : (element * 100) * (index + 1)

                    //
                    var textLable = "";
                    if(j.majorTicks === 5) {
                      if(j.ringWidth == 39) {
                        if(element >= 0 && element <= 10){
                          textLable = "Low";
                        }else if(element > 10 && element <= 20){
                                              textLable = "Satisfactory";
                        }else if(element > 20 && element <= 40){
                                              textLable = "Good";
                        }
                        else if(element > 40 && element <=70){
                                              textLable = "Very Good";
                        }
                        else if(element > 70 && element <= 100){
                                              textLable = "Excellent";
                        }
                      }
                      else {
  
                        if(element >= 0 && element <= 14){
                          textLable = "Low";
                        }else if(element > 14 && element <= 30){
                                              textLable = "Satisfactory";
                        }else if(element > 30 && element <= 45){
                                              textLable = "Good";
                        }
                        else if(element > 45 && element <= 72){
                                              textLable = "Very Good";
                        }
                        else if(element > 72 && element <= 100){
                                              textLable = "Excellent";
                        }
                      }
                    }else if(j.majorTicks === 4) {
                      if(element >= 0 && element < 61){
                        textLable = "Level 4";
                      }else if(element >= 61 && element < 71){
                        textLable = "Level 3";
                      }else if(element >= 71 && element < 81){
                        textLable = "Level 2";
                      }
                      else if(element >= 81 && element <= 100){
                        textLable = "Level 1";
                      }
                    }
                    
                    
                    
                    _d.selectAll(".segment-value")
                     .filter(function(){ 
                     return _d.select(this).text() == element
                     })
                     .text(textLable);
                     
                     });


 






 

 
 

 },
 update: function(b) {
                  var c = o(b),
                    d = j.minAngle + c * k;
                  a._d3_refs.pointer
.transition()
.duration(j.needleTransitionDuration)
.ease(a.getTransitionMethod(j.needleTransition))
.attr("transform", "rotate(" + d + ")"),
                    a._d3_refs.current_value_text.text(g(b));
},
                config: j
}
);
};
}
},
{
        key: "renderGauge",
        value: function renderGauge() {
(0, _d.select)(this.gaugeDiv)
.select("svg")
.remove(),
(this._d3_refs.powerGauge = this.getGauge()(this.gaugeDiv)),
            this._d3_refs.powerGauge.render(this.initialValue),
            this.updateReadings();
}
},
{
        key: "updateReadings",
        value: function updateReadings() {
(this._d3_refs.powerGauge.config.labelFormat = (0, _d.format)(
            this.props.valueFormat || ""
)),
(this._d3_refs.powerGauge.config.currentValueText =
              this.props.currentValueText || "${value}"),
            this._d3_refs.powerGauge.update(
              this.props.value
            //   this.props.role == "Team Leader" ?
            // // 
            // this.props.value >=0 && this.props.value <=14 ?
            // ((this.props.value - 0) * (1/7)) + 0 :
            // this.props.value > 14 && this.props.value <=30 ?
            // ((this.props.value - 14) * (5/4)) + 20 :
            // this.props.value > 30 && this.props.value <=45 ?
            // ((this.props.value - 30) * (4/3)) + 40 :
            // this.props.value > 45 && this.props.value <=72 ?
            // ((this.props.value - 45) * (20/27)) + 60 :
            // this.props.value > 72 && this.props.value <=100 ?
            // ((this.props.value - 72) * (10/14)) + 80 : 0
            // //
            // :
            // //
            // this.props.value >=0 && this.props.value <=10 ?
            // ((this.props.value - 0) * 2) + 0 :
            // this.props.value > 10 && this.props.value <=20 ?
            // ((this.props.value - 10) * 2) + 20 :
            // this.props.value > 20 && this.props.value <=40 ?
            // ((this.props.value - 20) * 1) + 40 :
            // this.props.value > 40 && this.props.value <=70 ?
            // ((this.props.value - 40) * (2/3)) + 60 :
            // this.props.value > 70 && this.props.value <=100 ?
            // ((this.props.value - 70) * (2/3)) + 80 : 0
            // //
             || 0);
}
},
{
        key: "getTransitionMethod",
        value: function getTransitionMethod(a) {
          switch (a) {
            case "easeLinear":
              return _d.easeLinear;
              break;
            case "easeQuadIn":
              return _d.easeQuadIn;
              break;
            case "easeQuadOut":
              return _d.easeQuadOut;
              break;
            case "easeQuadInOut":
              return _d.easeQuadInOut;
              break;
            case "easeCubicIn":
              return _d.easeCubicIn;
              break;
            case "easeCubicOut":
              return _d.easeCubicOut;
              break;
            case "easeCubicInOut":
              return _d.easeCubicInOut;
              break;
            case "easePolyIn":
              return _d.easePolyIn;
              break;
            case "easePolyOut":
              return _d.easePolyOut;
              break;
            case "easePolyInOut":
              return _d.easePolyInOut;
              break;
            case "easeSinIn":
              return _d.easeSinIn;
              break;
            case "easeSinOut":
              return _d.easeSinOut;
              break;
            case "easeSinInOut":
              return _d.easeSinInOut;
              break;
            case "easeExpIn":
              return _d.easeExpIn;
              break;
            case "easeExpOut":
              return _d.easeExpOut;
              break;
            case "easeExpInOut":
              return _d.easeExpInOut;
              break;
            case "easeCircleIn":
              return _d.easeCircleIn;
              break;
            case "easeCircleOut":
              return _d.easeCircleOut;
              break;
            case "easeCircleInOut":
              return _d.easeCircleInOut;
              break;
            case "easeBounceIn":
              return _d.easeBounceIn;
              break;
            case "easeBounceOut":
              return _d.easeBounceOut;
              break;
            case "easeBounceInOut":
              return _d.easeBounceInOut;
              break;
            case "easeBackIn":
              return _d.easeBackIn;
              break;
            case "easeBackOut":
              return _d.easeBackOut;
              break;
            case "easeBackInOut":
              return _d.easeBackInOut;
              break;
            case "easeElasticIn":
              return _d.easeElasticIn;
              break;
            case "easeElasticOut":
              return _d.easeElasticOut;
              break;
            case "easeElasticInOut":
              return _d.easeElasticInOut;
              break;
            case "easeElastic":
              return _d.easeElastic;
              break;
            case "easeElastic":
              return _d.easeElastic;
              break;
            default:
              return _d.easeQuadInOut;
}
}
}
]),
    b
);
})(_react2.default.Component);
ReactSpeedometer.displayName = "ReactSpeedometer";
(ReactSpeedometer.propTypes = {
  value: _propTypes2.default.number.isRequired,
  minValue: _propTypes2.default.number.isRequired,
  maxValue: _propTypes2.default.number.isRequired,
  forceRender: _propTypes2.default.bool.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  fluidWidth: _propTypes2.default.bool.isRequired,
  segments: _propTypes2.default.number.isRequired,
  needleColor: _propTypes2.default.string.isRequired,
  needleHeightRatio:0.3,
  startColor: _propTypes2.default.string.isRequired,
  endColor: _propTypes2.default.string.isRequired,
  needleTransition: _propTypes2.default.string.isRequired,
  needleTransitionDuration: _propTypes2.default.number.isRequired,
  ringWidth: _propTypes2.default.number.isRequired,
  textColor: _propTypes2.default.string.isRequired,
  valueFormat: _propTypes2.default.string.isRequired,
  currentValueText: _propTypes2.default.string.isRequired,
  role: _propTypes2.default.string.isRequired
}),
(ReactSpeedometer.defaultProps = {
    value: 0,
    minValue: 0,
    maxValue: 1e3,
    forceRender: !1,
    width: 400,
    height: 250,
    fluidWidth: !1,
    segments: 5,
    needleColor: "steelblue",
    startColor: "#FF471A",
    endColor: "#33CC33",
    needleTransition: "easeQuadInOut",
    needleTransitionDuration: 300,
    ringWidth: 40,
    textColor: "#666",
    valueFormat: "",
    currentValueText: "${value}",
    role:"Team Member"
}),
(exports.default = ReactSpeedometer);


// WEBPACK FOOTER //
// ./src/_components/common/CustomSpeedometer/CustomSpeedometer.js